
import axios from 'axios'
export function invest(data){
  return axios.post('https://api.xcxzhan.com/site/site/invest',data)
    .then(res => {
      if(res.data.code === 0){
        return true
      }else{
        return Promise.reject('return code error')
      }
    })
}


// WEBPACK FOOTER //
// ./src/apps/siteindex/api.js